<template>
  <i :class="classes" />
</template>

<script>
export default {
  name: "ConfettiIcon",
  props: {
    classNames: {
      default: "",
      type: String,
    },
    icon: {
      required: true,
      type: String,
    },
    svg: {
      type: Boolean,
    },
  },
  computed: {
    classes() {
      const classNames = [
        "confetti-icon",
        `icon-${this.icon}`,
        this.classNames,
      ];

      if (this.svg) {
        classNames.push(`confetti-icon--svg`);
      }

      return classNames;
    },
  },
};
</script>

<style lang="scss" scoped>
.confetti-icon--svg.icon-spinner {
  background-image: url("../assets/icons/spinner.svg");
  block-size: 24px;
  display: inline-block;
  inline-size: 24px;
}
</style>
